import { Link } from "react-router-dom";
import { featuredCategories } from "@/mocks/categories";

export default function GuideSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Latest Buying Guides
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            Learn how to make the most of the AllChinaBuy Spreadsheet with our in-depth resources
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Main Guide Card */}
          <Link
            to="/guide/allchinabuy-sheet-complete-guide"
            className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-book-open-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 leading-snug">
              How To Use AllChinaBuy Spreadsheet
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              A complete beginner guide covering everything from navigation to advanced shopping tips and strategies.
            </p>
            <span className="text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap flex items-center gap-1">
              Read Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </span>
          </Link>

          {/* Placeholder Guide 2 */}
          <Link
            to="/guide/allchinabuy-sheet-complete-guide"
            className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-12 h-12 bg-secondary-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-ship-line text-secondary-600 text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 leading-snug">
              Shipping & Delivery Guide
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Understand shipping options, delivery timelines, and how to track your orders from the spreadsheet links.
            </p>
            <span className="text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap flex items-center gap-1">
              Read Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </span>
          </Link>

          {/* Placeholder Guide 3 */}
          <Link
            to="/guide/allchinabuy-sheet-complete-guide"
            className="group bg-background-100 border border-background-200/70 rounded-2xl p-6 hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-12 h-12 bg-accent-100 rounded-xl flex items-center justify-center mb-4">
              <i className="ri-search-eye-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 leading-snug">
              QC Inspection Guide
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Learn how to evaluate product quality before purchasing using community-tested inspection checklists.
            </p>
            <span className="text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap flex items-center gap-1">
              Read Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}